export default __webpack_public_path__ + "static/media/icon-ftr-arrow.e77394e0.svg";